/* src/app/shared-module/components/image-viewer/image-viewer.component.scss */
.image-viewer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
  width: 100%;
  height: 100%;
  touch-action: none;
}
.image-viewer-container img {
  transition: transform 0.3s;
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
}
.zoom-controls {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}
/*# sourceMappingURL=image-viewer.component.css.map */
